import React from 'react';
import phoneIcon from 'assets/events/icons/phone.png'
import emailIcon from 'assets/events/icons/email.png'
import verification from 'assets/icons/verified.png'


function Index({ serialNo, data, onConfirm, handleCancel, btnText, btnColor, viewUser, isVerified, ticketCount, additionalGuests, amountPaid, couponApplied, bookedOn, currency = 'INR' }) {

    const hasBooking = ticketCount !== undefined && ticketCount !== null;
    const tickets = Number.isInteger(Number(ticketCount)) && Number(ticketCount) > 0 ? Number(ticketCount) : 1;
    const additionalSlots = Math.max(0, tickets - 1);
    const guests = Array.isArray(additionalGuests) ? additionalGuests.filter(guest => guest && (guest.name || guest.email || guest.phone)) : [];
    const missingGuests = Math.max(0, additionalSlots - guests.length);

    const hasPaidAmount = amountPaid !== null && amountPaid !== undefined && String(amountPaid).trim() !== '' && Number.isFinite(Number(amountPaid));
    const formattedAmount = hasPaidAmount ? new Intl.NumberFormat('en-IN', { style: 'currency', currency: /^[A-Z]{3}$/.test(currency) ? currency : 'INR' }).format(Number(amountPaid)) : '—';
    const bookingDate = bookedOn ? new Date(bookedOn) : null;
    const formattedDate = bookingDate && Number.isFinite(bookingDate.getTime()) ? new Intl.DateTimeFormat('en-IN', { timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(bookingDate) + ' IST' : '—';
    const coupon = typeof couponApplied === 'string' ? couponApplied.trim() : '';

    return (
        <div className="w-full p-4 overflow-hidden text-center bg-white shadow-lg rounded-3xl">
            <div className="flex gap-2 mt-4 relative">
                <div className="mb-4 text-sm font-semibold text-gray-500">{serialNo}</div>
                <div onClick={viewUser} className="relative w-full h-40 overflow-hidden rounded-3xl">
                    {data?.photo ? (
                        <img className="object-cover w-full h-full cursor-pointer"
                            src={data?.photo} alt="Card" />
                    ) : (
                        <div className="flex items-center justify-center w-full h-full text-center bg-gray-300 cursor-pointer">
                            No Profile Pic
                        </div>
                    )}
                    {/* Verification icon positioned over the image */}
                    {isVerified &&
                        <img src={verification} alt="Verified"
                            className="absolute bottom-2 right-2 w-7 h-7  rounded-full p-1 bg-white" />
                    }
                </div>
            </div>

            <div className="mt-4 text-xl font-medium">
                {data?.name}
            </div>
            <p className="flex items-center mt-2 text-gray-600">
                <img src={phoneIcon} alt="phoneIcon" className='me-2' />
                {data?.phone}
            </p>
            <p className="flex items-center mt-2 text-gray-600 me-2" title={data?.email}>
                <img src={emailIcon} alt="emailIcon" className="me-2" />
                {data?.email ? data.email : "No Email Provided"}
            </p>

            {hasBooking && (
                <section aria-label="Booking details" className="mt-4 rounded-xl border border-gray-200 bg-gray-50 p-3 text-left text-sm">
                    {additionalSlots > 0 && <p className="font-semibold text-gray-900">Additional slots booked: {additionalSlots}</p>}
                    {additionalSlots > 0 && guests.length > 0 && (
                        <ol className="mt-3 space-y-3" aria-label="Additional guests">
                            {guests.map((guest, index) => (
                                <li key={index} className="border-t border-gray-200 pt-2 break-words">
                                    <p className="font-semibold text-gray-900">Guest {index + 1}{guest.name ? `: ${guest.name}` : ''}</p>
                                    {guest.email && <p className="mt-1 text-gray-600">{guest.email}</p>}
                                    {guest.phone && <p className="mt-1 text-gray-600">{guest.phone}</p>}
                                </li>
                            ))}
                        </ol>
                    )}
                    {additionalSlots > 0 && missingGuests > 0 && <p className="mt-3 text-xs text-gray-500">{guests.length === 0 ? 'Guest details not provided.' : `Details not provided for ${missingGuests} additional ${missingGuests === 1 ? 'guest' : 'guests'}.`}</p>}
                    <dl className="mt-3 space-y-2 break-words text-gray-700">
                        <div><dt className="inline font-semibold">Amount Paid : </dt><dd className="inline">{formattedAmount}</dd></div>
                        {coupon && <div><dt className="inline font-semibold">Coupon Applied : </dt><dd className="inline">{coupon}</dd></div>}
                        <div><dt className="inline font-semibold">Booked On : </dt><dd className="inline">{formattedDate}</dd></div>
                    </dl>
                </section>
            )}

            <div className="flex items-center justify-around">
                {onConfirm &&
                    <button
                        onClick={onConfirm}
                        className={`mt-4 bg-${btnColor}  text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline`}>
                        {btnText}
                    </button>
                }
                {handleCancel &&
                    <button
                        onClick={handleCancel}
                        className="mt-4 bg-brandRed  text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
                        Cancel
                    </button>
                }
            </div>
        </div>
    );
}

export default React.memo(Index)
